function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { default as classNames, default as classnames } from 'classnames';
import { includes } from 'lodash';
import map from 'lodash/fp/map';
import T from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import useBreakpoint from '../../hooks/useBreakpoint';
import { setListJobStatus } from '../../redux/actions';
import text from '../../text';
import { ALL_STATUS, statusLight, statuses } from './consts';
import SearchControl from './filters/searchControl';
import { useProjectListing } from './projectListing';
var ProjectListingControl = function(param) {
    var statusCounts = param.statusCounts;
    var dispatch = useDispatch();
    var isBreakpointXL = useBreakpoint([
        'md',
        'lg'
    ]);
    var _useState = _sliced_to_array(useState([]), 2), statusFilters = _useState[0], setStatusFilters = _useState[1];
    var handleAddStatusFilter = function(key) {
        var statusFiltersCopy = _to_consumable_array(statusFilters);
        if (statusFiltersCopy.includes(key)) {
            statusFiltersCopy = statusFiltersCopy.filter(function(filter) {
                return filter !== key;
            });
        } else {
            statusFiltersCopy.push(key);
        }
        setStatusFilters(statusFiltersCopy);
    };
    useEffect(function() {
        dispatch(setListJobStatus(ALL_STATUS));
    }, []);
    useEffect(function() {
        dispatch(setListJobStatus(statusFilters.length ? statusFilters : ALL_STATUS));
    }, [
        statusFilters
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-3",
        id: "ProjectListingControlContainer"
    }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        sm: 12,
        xl: 3,
        className: "search-control-container"
    }, /*#__PURE__*/ React.createElement(SearchControl, null)), /*#__PURE__*/ React.createElement(Col, {
        sm: 12,
        xl: 9,
        className: classnames('d-flex align-items-center', {
            'px-0 justify-content-end': !isBreakpointXL,
            'justify-content-center': isBreakpointXL
        })
    }, /*#__PURE__*/ React.createElement("div", {
        id: "ProjectListingControl"
    }, /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", {
        key: "statusFilter",
        className: "mx-0 status-filter-label"
    }, /*#__PURE__*/ React.createElement("span", null, text('statusFilter'))), map(function(param) {
        var name = param.name, key = param.key, isFilterable = param.isFilterable;
        if (!isFilterable) return;
        return /*#__PURE__*/ React.createElement("li", {
            "aria-label": name,
            key: key,
            className: classNames('ml-2', key, {
                'is-active': includes(statusFilters, key)
            }),
            onClick: function() {
                handleAddStatusFilter(key);
            }
        }, /*#__PURE__*/ React.createElement("span", {
            className: "orderStatusControl"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "status-circle ".concat(statusLight[key])
        }), statusCounts[key] || 0, " ", name));
    }, statuses))))));
};
ProjectListingControl.propTypes = {
    statusCounts: T.object.isRequired
};
var ProjectListingControlWithRedux = function() {
    var statusCounts = useProjectListing().statusCounts;
    return /*#__PURE__*/ React.createElement(ProjectListingControl, {
        statusCounts: statusCounts
    });
};
export default ProjectListingControlWithRedux;
